'use strict';
define(['app'], function (app) {
    // Transclusion keeps the native input's model and form validation in its parent.
    app.component('stSearchField', {
        transclude: true,
        bindings: {variant: '@'},
        templateUrl: 'app/components/st-search-field/st-search-field.html'
    });
});
